export const featuredPortfolio = [
    {
      id: 1,
      title: "Phishing Awareness Website ",
      img: "/assets/Phishing-app.png",
      languageUsed :  "Python/Django     HTML/CSS     API ",
      gitLink:"https://github.com/offbr0wn/Phish-website",
      netLink:"https://cryptic-meadow-81808.herokuapp.com/login/?next=/",
    },
    {
      id: 1,
      title: "Weather App",
      img:"/assets/weatherApp.PNG",
      languageUsed : "ReactJS  HTML/CSS  ",
      gitLink:"https://github.com/offbr0wn/Weather-app",
      netLink:"https://weatheryapplication.netlify.app",
    },
    {
      id: 2,
      title: "Personal Portfolio",
      img: "/assets/Portfolio.mp4",
      languageUsed : "ReactJS  HTML/SCSS ",
      gitLink:"https://github.com/offbr0wn/Website-Porfolio",
      netLink:"https://weatheryapplication.netlify.app",
    },

    {
      id: 3,
      title: "Tiktok Redesign",
      img:"https://cdn.dribbble.com/users/7024523/screenshots/16510745/media/64ad783bd3527e3ab6d58e5d4d560567.png",
      netLink:"https://dribbble.com/shots/16510745-A-Take-on-Tiktok-Redesign",
    },
   
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Phishing Awareness Website ",
      img: "/assets/Phishing-app.png",
      languageUsed :  "Python/Django     HTML/CSS     API ",
      gitLink:"https://github.com/offbr0wn/Phising-Awareness-Website",
      netLink:"https://cryptic-meadow-81808.herokuapp.com/login/?next=/",
    },
    {
      id: 1,
      title: "Weather App",
      img:"/assets/weatherApp.PNG",
      languageUsed : "ReactJS  HTML/CSS  ",
      gitLink:"https://github.com/offbr0wn/Phising-Awareness-Website",
      netLink:"https://weatheryapplication.netlify.app",
    },
    {
      id: 1,
      title: "Personal Portfolio",
      img: "/assets/Portfolio.mp4",
      languageUsed : "ReactJS  HTML/SCSS ",
      gitLink:"https://github.com/offbr0wn/Website-Porfolio",
      netLink:"https://weatheryapplication.netlify.app",
    },

   
  ];
  

  export const designPortfolio = [
    {
      id: 3,
      title: "Tiktok Redesign",
      img:"https://cdn.dribbble.com/users/7024523/screenshots/16510745/media/64ad783bd3527e3ab6d58e5d4d560567.png",
      netLink:"https://dribbble.com/shots/16510745-A-Take-on-Tiktok-Redesign",
    },
    {
      id: 3,
      title: "Coming Soon",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
      netLink:"https://dribbble.com/off_br0wn",
    },
  

  ];
  
